<script>
    import { fade } from 'svelte/transition';
    import {link , push} from 'svelte-spa-router'
    import fetchData from '../api.js';
    import UserStore from '../stores/user';
    import { _ } from "svelte-i18n";
    import { onMount } from 'svelte';
    import Header from '../components/Header.svelte'; 
    import TopInfo from '../components/TopInfo.svelte';  
    import Preloader from '../components/Preloader.svelte'; 

    let isLoading = false;

    let settings = {
        shipping_push_supplier_code  : '',
        shipping_push_supplier_name  : '',
        shipping_push_supplier_phone  : '',
        shipping_push_supplier_email : '',
        shipping_mark_fullfiled :'1',
        shipping_push_products_in_comments:'0',
        enable_pickup : "0",
        shipping_pickup_price  : '',
        shipping_free_pickup_above  : '',
        limit_results  : '',
        shipping_push_supplier : shipping_push_supplier,
        shipping_pull_platform : shipping_pull_platform
    }

    onMount(async() => {

        console.log('UserStore',$UserStore)

        if (!$UserStore || !$UserStore.data){
            push('/login');
            return;
        }

        let temp_settings = {}

        console.log($UserStore.settings)

        if ($UserStore.settings && $UserStore.settings.shipping_settings && $UserStore.settings.shipping_settings.shipping_method) {
            
            let type = Array.isArray($UserStore.settings.shipping_settings.shipping_method);

            // console.log('type',type)
            // console.log('ttt',$UserStore.settings.shipping_settings.shipping_method)
            
            if (type) {
                temp_settings = $UserStore.settings.shipping_settings.shipping_method[0];
            } else {
                temp_settings = $UserStore.settings.shipping_settings.shipping_method;
            }            

        }

        for(var key in temp_settings) {
            settings[key] = temp_settings[key]
        }
        

        // let postData = {};

        // postData.action = 'get_shipment';
        // postData.token = $UserStore.data
        // let response = await fetchData(postData);

        // if (response.data) {


        // }
        
    })


    const handleSubmit = async() => {

        //alert(1)

        isLoading = true;

        let postData = {};

        postData.action = 'w_update_shipping_methods';
        postData.token = $UserStore.data
        if (typeof settings=='object') {
            postData.datalogics_shipping_method = [settings];
        } else {
            postData.datalogics_shipping_method = settings;
        }

        let response = await fetchData(postData);
        if (response.data) {

            $UserStore.settings = response.data;
            localStorage.setItem('user',JSON.stringify($UserStore))            

            alert('הנתונים נשמרו בהצלחה')

        }



        isLoading = false;


    }

    
</script>

<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading}/>
    <Header />
    <div class="page">    
        <TopInfo/>
        <div class="shipment">
            <h1>{$_('settings.title')}</h1>        
            <div class="shipment-flex">
                <div class="shipment_origin">
                    <div class="input_box">
                        <div class="input_con">
                            <label><i class="fa-solid fa-asterisk"></i> {$_('settings.contract_number')}</label>
                            <input type="text" bind:value={settings.shipping_push_supplier_code}>
                        </div>      
                        <div class="input_con">
                            <label><i class="fa-solid fa-asterisk"></i> {$_('settings.label_name')}</label>
                            <input type="text" bind:value={settings.shipping_push_supplier_name}>
                        </div>
                    </div>                    
                    <div class="input_box">
                        <div class="input_con">
                            <label><i class="fa-solid fa-asterisk"></i> {$_('settings.phone')}</label>
                            <input type="text" bind:value={settings.shipping_push_supplier_phone}>
                        </div>             
                        <div class="input_con">
                            <label>{$_('shipment.email')}</label>
                            <input type="text" bind:value={settings.shipping_push_supplier_email}>
                        </div>
                    </div>
                    <div class="input_box">
                        <div class="input_con">
                            <label><i class="fa-solid fa-asterisk"></i> {$_('settings.shipping_mark_fullfiled')}</label>
                            <select bind:value={settings.shipping_mark_fullfiled}>
                                <option value="1">{$_('settings.yes')}</option>
                                <option value="0">{$_('settings.no')}</option>
                            </select>
                        </div> 
                        <div class="input_con">
                            <label><i class="fa-solid fa-asterisk"></i> {$_('settings.shipping_push_products_in_comments')}</label>
                            <select bind:value={settings.shipping_push_products_in_comments}>
                                <option value="0">{$_('settings.no')}</option>
                                <option value="1">{$_('settings.yes')}</option>                                
                            </select>
                        </div>    
                    </div>
                    
                    <!--
                    <div class="input_box">
                        <div class="input_con">
                            <label><i class="fa-solid fa-asterisk"></i> {$_('settings.city')}</label>
                            <input type="text" bind:value={settings.shipping_push_supplier_city}>
                        </div>
                        <div class="input_con">
                            <label><i class="fa-solid fa-asterisk"></i> {$_('settings.street')}</label>
                            <input type="text" bind:value={settings.shipping_push_supplier_street}>
                        </div>
                        <div class="input_con">
                            <label><i class="fa-solid fa-asterisk"></i> {$_('settings.house')}</label>
                            <input type="text" bind:value={settings.shipping_push_supplier_house}>
                        </div>
                    </div>
                    -->
                    <div class="input_box">
                        <div class="input_con radio">
                            <input id="pudo_enabled1" type="radio" name="pudo_enabled" bind:group={settings.enable_pickup} value="1">
                            <label for="pudo_enabled1"><i class="fa-solid fa-asterisk"></i> {$_('settings.using_pudo')}</label>
                        </div>
                        <div class="input_con radio">
                            <input id="pudo_enabled2" type="radio" name="pudo_enabled" bind:group={settings.enable_pickup}  value="0">
                            <label for="pudo_enabled2"><i class="fa-solid fa-asterisk"></i> {$_('settings.not_using_pudo')}</label>
                        </div>
                    </div>
                    {#if settings.enable_pickup=="1"}
                    <div class="input_box">
                        <div class="input_con">
                            <label><i class="fa-solid fa-asterisk"></i> {$_('settings.pudo_price')}</label>
                            <input type="text" bind:value={settings.shipping_pickup_price}>
                        </div>
                        <div class="input_con">
                            <label><i class="fa-solid fa-asterisk"></i> {$_('settings.pudo_free_above')}</label>
                            <input type="text" bind:value={settings.shipping_free_pickup_above}>
                        </div>                        
                        <div class="input_con">
                            <label><i class="fa-solid fa-asterisk"></i> {$_('settings.limit_results')}</label>
                            <input type="text" bind:value={settings.limit_results}>
                        </div>
                    </div>  
                    {/if} 
                </div> 
            </div> 
  
            <div class="shipment-flex-button">
                <div class="create_button" on:click={ handleSubmit }>{$_('settings.save')}</div>
            </div> 
        </div>
        
    </div>
</div>

